import LocalState from '../../state/LocalState';
import logger from '../../log';
import { ApiEvents, ConnectionEventTypes } from '@kollective-frontend/ksdk-api';
import { DiagnosticCode } from './constants';
import { generateSessionDiagnosticArgs } from './GenerateDiagnostic';
import { sendSessionDiagnostic } from './sendDiagnostic';
const log = logger.getLogger(__filename);

export interface DispatchedEventConnectionEventTypes {
  type: ApiEvents.WEBSOCKET_CONNECT;
  data: ConnectionEventTypes;
}

const handleWebsocketConnect = async (
  event: DispatchedEventConnectionEventTypes,
  state: LocalState
): Promise<void> => {
  log.info('capturing event:', event);
  const { data } = event || {};
  if (!data || data.status == 'success') {
    return;
  }
  const diag = generateSessionDiagnosticArgs({
    code: DiagnosticCode.WEBSOCKET_CONNECT_ISSUE,
    message: data.message || 'no message available',
    from: data.type,
    state
  });
  await sendSessionDiagnostic(diag);
};
export default handleWebsocketConnect;
